import React, { useEffect, useState, useRef } from "react";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import caseStudiesContent from "./caseStudiesContent";
import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../header";
import FooterComponent from "../footer";
import CaseStudiesComponent from "../caseStudies";

import "../../styles/commonStyle.scss";
import "../../styles/caseStudies/caseStudiesDetails.scss";

const SingleCaseStudiesDetailsComponent = () => {
  const navigate = useNavigate();
  const { caseStudies } = useParams();
  const refs = {
    Home: useRef(null),
    Services: useRef(null),
    "Case Studies": useRef(null),
    Blog: useRef(null),
    Contact: useRef(null),
    About: useRef(null),
  };

  const handleScrollToPortion = (section) => {
    if (section === "About") {
      navigate(`/aboutUs`);
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  return (
    <div className="single-case-studies-details-wrapper">
      <HeaderComponent
        handleScrollToPortion={handleScrollToPortion}
        // headerName={"WizzGeeks"}
      />
      {caseStudiesContent.caseStudies.map((data) => {
        return (
          data.name === caseStudies && (
            <div className="single-case-studies-content-main-wrapper">
              <div
                className="case-studies-back-wrapper cursor-pointer"
                onClick={() => {
                  navigate("/", { state: { scrollTo: "Case Studies" } });
                }}
              >
                <img src="../../images/ourServices/leftArrow.svg"></img>
                <p>Back to Case Studies</p>
              </div>
              <div className="single-case-studies-content-wrapper">
                <div className="single-case-studies-title-name">
                  {data.related}
                </div>
                <div className="single-case-studies-heading-name">
                  {data.headingName}
                </div>
                <div className="single-case-studies-description-name">
                  {data.description}
                </div>
              </div>
              <div className="single-case-studies-left-right-main-wrapper">
                <div className="single-case-studies-content-left-wrapper width-65">
                  <div className="single-case-studies-image-wrapper width-100">
                    <img className="width-100" src={data.image}></img>
                  </div>
                  <div className="single-case-studies-left-content-wrapper">
                    {data.topic.theChallenge && (
                      <div className="single-case-heading-conent-wrapper">
                        <span>The Challenge</span>
                        {data.topic.theChallenge}
                      </div>
                    )}
                    {data.topic.ourSolution && (
                      <div className="single-case-heading-conent-wrapper">
                        <span>Our Solution</span>
                        {data.topic.ourSolution}
                      </div>
                    )}
                    {/* <div className="single-case-heading-conent-wrapper">
                      <span>The Results</span>
                      {data.topic.theResults}
                    </div> */}
                    {data.topic.conclusion && (
                      <div className="single-case-heading-conent-wrapper">
                        <span>Conclusion</span>
                        {data.topic.conclusion}
                      </div>
                    )}
                  </div>
                </div>
                <div className="single-case-studies-content-right-wrapper width-35">
                  <Card>
                    <CardContent className="single-case-card-content-wrapper">
                      <div className="single-case-card-content-details-heading">
                        Project Details
                      </div>
                      <div className="single-case-card-content-details">
                        Client <span>Global Financial Services</span>
                      </div>
                      <div className="single-case-card-content-details">
                        Industry <span>Financial Services</span>
                      </div>
                      <div className="single-case-card-content-details">
                        Services Provided <span>Brand Strategy</span>
                        <span>SEO Optimization</span>
                        <span>Lead Generation</span>
                      </div>
                      <button>Discuss Your Project</button>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          )
        );
      })}
      <CaseStudiesComponent
        titleName={"Related Case Studies"}
        selectedId={caseStudies}
      />
      <FooterComponent />
    </div>
  );
};

export default SingleCaseStudiesDetailsComponent;
